import { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

interface ConfirmEmailDialogProps {
  open: boolean;
  email: string;
  onConfirm: (email: string) => void;
  onCancel: () => void;
  loading?: boolean;
}

export function ConfirmEmailDialog({
  open,
  email,
  onConfirm,
  onCancel,
  loading = false,
}: ConfirmEmailDialogProps) {
  const [enteredEmail, setEnteredEmail] = useState("");

  useEffect(() => {
    if (open) {
      setEnteredEmail("");
    }
  }, [open]);

  const handleConfirm = () => {
    onConfirm(enteredEmail.trim());
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        if (!loading && !o) onCancel();
      }}
    >
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Confirm Registration</DialogTitle>
          <DialogDescription>
            Are you sure the provided information is correct? The assessment
            email will be sent to
            <span className="font-medium"> {email} </span>. Please re-enter
            your email below to confirm.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 pt-2">
          <Input
            type="email"
            placeholder="Enter email again"
            value={enteredEmail}
            onChange={(e) => setEnteredEmail(e.target.value)}
            disabled={loading}
          />
        </div>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button type="button" onClick={handleConfirm} disabled={loading}>
            {loading ? "Submitting..." : "Confirm & Submit"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
